import React from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import './sec3-p3.css'




const Sec3p3 = ({ bookingData, setBookingData }) => {

const [headers, setheaders]= useState([]);

const [ticket, settickets]= useState([]);
const [selectedCard, setSelectedCard] = useState(null);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);




  useEffect(() => {
  const gettickets = async()=>{
      const res = await supabase.from('ticket').select('*').order('id', { ascending: true });;;

  settickets(res.data);

    if (res.data && res.data.length > 0) {
      setSelectedCard(0);

      setBookingData(prev => ({
        ...prev,
        ticket: res.data[0]
      }));
    }

  }
  gettickets();
  }, []);



 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);





    return ( 
        <section className='sec3-page3' ref={secRef}>
        <section className='container-cards-sec2-p3'>
                <section className='big-cont-sec2--p3'>
                    <section className='main-cont-sec3-p3 '>
                            <h1 className='header-sec3-p3'>{headers?.[14]?.header}</h1>
                            <section className='container-cards-contact-sec3-p3'>
{ticket?.map((item, index) => (
                                    <article
                                        key={index}
                                        className={`MAIN-CARD-SEC3-P3 ${selectedCard === index ? "active-card" : ""}`}
                                        onClick={() => {
                                            setSelectedCard(index);

                                            setBookingData(prev => ({
                                              ...prev,
                                              ticket: item
                                            }));
                                          }}
                                    >
                                    <article className='part1-card-sec3-p3'>
                                        <article className='roww-card-sec3-p3'>
                                            <h2 className='hedaer-card-sec3-p3'>{item.name}</h2>
                                            <h2 className='ticke0-numb-sec3-p3'>{item.price}EGP</h2>
                                        </article>
                                        <ul className='biglist-sec-p3'>
                                                  {item.description?.split("\n").map((line, index) => (
                                                <li key={index} className="para-sec3-p3">
                                                {line}
                                                </li>
                                            ))}
                                        </ul>
                                    </article>
                                    <img className='img-sec3-p3' src={item.image} alt={item.img_alt}></img>
                                </article>
))}


                            </section>


                    </section>
                </section>
        </section>
        </section>
     );
}
 
export default Sec3p3;